'use client';

import { c as _c } from "react/compiler-runtime";
import { Card, CardContent } from '@achra/ui/card';
import { OnboardingStepper } from './onboarding-stepper';
import { OnboardingStepperCompact } from './onboarding-stepper-compact';
import { SupportCallout } from './support-callout';
import type { ReactNode } from 'react';
interface OnboardingShellProps {
  currentStep: number;
  // Forwarded to the stepper so the active step shows a spinner while its work runs.
  loading?: boolean;
  children: ReactNode;
}

// `children` (the step content) holds form state, so it is rendered exactly
// once. The stepper and support callout are stateless, so each layout renders
// its own copy and the unused one is hidden via `lg:` visibility — this keeps a
// single grid that reflows instead of swapping trees at the breakpoint.
function OnboardingShell(t0) {
  const $ = _c(16);
  const {
    currentStep,
    loading: t1,
    children
  } = t0;
  const loading = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== currentStep || $[1] !== loading) {
    t2 = <OnboardingStepper currentStep={currentStep} loading={loading} />;
    $[0] = currentStep;
    $[1] = loading;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SupportCallout className="border-border border-t pt-6" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <Card className="hidden lg:block"><CardContent className="flex flex-col gap-6">{t2}{t3}</CardContent></Card>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== currentStep || $[7] !== loading) {
    t5 = <Card className="lg:hidden"><CardContent><OnboardingStepperCompact currentStep={currentStep} loading={loading} /></CardContent></Card>;
    $[6] = currentStep;
    $[7] = loading;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== children) {
    t6 = <div className="min-w-0">{children}</div>;
    $[9] = children;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Card className="lg:hidden"><CardContent><SupportCallout /></CardContent></Card>;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t8 = <div className="mx-auto grid w-full max-w-3xl grid-cols-1 gap-6 lg:max-w-6xl lg:grid-cols-[18rem_minmax(0,1fr)] lg:items-start lg:gap-8">{t4}{t5}{t6}{t7}</div>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}
export { OnboardingShell };